module.exports = __webpack_public_path__ + "img/laptop.3bb6d4d3.svg";